import array from '../../../assets/images/portfolios/portfolio'
import PortfolioItem from './PortfolioItem'

function PortfolioSection() {
	return (
		<section className='mt-[50px] sm:mt-[70px]' id='portfolio'>
			<div className='flex flex-col items-center'>
				<p className='text-center text-black dark:text-white font-medium text-[20px] sm:text-[26px] xl:text-[32px]'>
					Портфолио
				</p>
				<p className='mt-[15px] text-dark-100 sm:mt-[25px] text-center w-[300px] sm:w-[360px]'>
					В этом блоке предоставлена часть моего портфолио, все работы
					были выставлены с разрешения заказчиков.
				</p>
			</div>
			<div className='mt-[20px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[15px]'>
				{array?.map((item, index) => (
					<PortfolioItem
						key={index}
						title={item.title}
						image={item.image}
					/>
				))}
			</div>
			<div className='mt-[28px] flex justify-center'>
				<a href='#' className='text-[18px] text-yellow-100 font-medium'>
					{'Смотреть больше >'}
				</a>
			</div>
		</section>
	)
}

export default PortfolioSection
